import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
      token: null,
      tokenExpire: null,
      tagsStoreList: [],
      language: Cookies.get('language') || 'en',

  },
  mutations: {
      saveToken(state, data) {
          state.token = data;
          window.localStorage.setItem("Token", data);
      },
      saveTokenExpire(state, data) {
          state.tokenExpire = data;
          window.localStorage.setItem("TokenExpire", data);
      },
      saveTagsData(state, data) {
          state.tagsStoreList = data;
          sessionStorage.setItem("Tags",data)
      },
      SET_LANGUAGE: (state, language) => {
          state.language = language
          Cookies.set('language', language)
      },
      SET_ARMY_TYPES: (state, types) => {
        state.armyTypes = types
      }

  },
  actions: {
      setLanguage({ commit }, language) {
          commit('SET_LANGUAGE', language)
      },
      fetchArmyTypes({ commit }) {
        return new Promise((resolve, reject) => {
          getArmyTypeList({ page: 1, pageSize: 100 }).then(res => {
            commit('SET_ARMY_TYPES', res.data.response.data)
            resolve()
          }).catch(error => {
            reject(error)
          })
        })
      },
  }
})
